<template>
    <button @click="save" type="submit" :class="['btn btn-save', { 'highlight': colorChanged }]">Save</button>
</template>

<script>
    import DraftSwatch       from "../../../Store/DraftSwatch";
    import Swatches          from "../../../Store/Swatches";
    import UsesActivePalette from "../Palette/UsesActivePalette";
    import SaveShortCutListener from "../../../../../Lib/helpers/SaveShortCutListener";

    export default {
        name: "SaveButton",
		extends: UsesActivePalette,
		
        computed: {
            colorChanged() {
                let draft = new DraftSwatch();
                return JSON.stringify(this.activeSwatch.color) !== JSON.stringify(draft.rgb());
            },
        },

        data() {
            return {
                shortCut: null,
            }
        },

        methods: {
            save() {
                let draft    = new DraftSwatch();
                let swatches = new Swatches(this.palette.id);

                draft.saveDraft(swatches);
            },
        },

        mounted() {
            this.shortCut = new SaveShortCutListener(() => {
                this.save();
            });
        },

        beforeDestroy() {
            this.shortCut.removeEventListener();
        }
    }
</script>

<style scoped>

</style>